import { render, staticRenderFns } from "./SurrenderRequestDelNPop.vue?vue&type=template&id=99b7b0b2&scoped=true"
import script from "./SurrenderRequestDelNPop.vue?vue&type=script&lang=js"
export * from "./SurrenderRequestDelNPop.vue?vue&type=script&lang=js"
import style0 from "./SurrenderRequestDelNPop.vue?vue&type=style&index=0&id=99b7b0b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b7b0b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99b7b0b2')) {
      api.createRecord('99b7b0b2', component.options)
    } else {
      api.reload('99b7b0b2', component.options)
    }
    module.hot.accept("./SurrenderRequestDelNPop.vue?vue&type=template&id=99b7b0b2&scoped=true", function () {
      api.rerender('99b7b0b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/SurrenderRequestDelNPop.vue"
export default component.exports